import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import '../src/assets/css/App.css';
import LoginFrom from './Components/BeforeLogin/LoginForm';
import Dashboard from './Components/Dashboard/Index';
import UsageReports from './Components/UsageReport/Index';
import OtpFrom from './Components/BeforeLogin/Otpform';
import AddUser from './Components/UserManagement/User/AddUser';
import AllUser from './Components/UserManagement/User/AllUser';
import EditUser from './Components/UserManagement/User/EditUser';
import PrivateRoute from "./PrivateRoute";
import OtpRoute from "./OtpRoute";
import BlkUsageReports from './Components/BlkUsageReport/Index';
import ChangePasswordRoute from "./ChangePasswordRoute";
import AddHotel from './Components/HotelManagement/AddHotel';
import HotelListing from './Components/HotelManagement/HotelListing';
import EditHotel from './Components/HotelManagement/EditHotel';
import AddRole from './Components/UserManagement/Role/AddRole';
import AllRole from './Components/UserManagement/Role/AllRole';
import EditRole from './Components/UserManagement/Role/EditRole';
import ChangePassword from './Components/ChangePassword/Index';
import ChangePasswordBeforeLogin from './Components/BeforeLogin/ChangePasswordBeforeLogin';
import AllPermission from './Components/UserManagement/Role/AllPermission';
import ReportVerification from './Components/UsageReport/ReportVerification'
import { useMenu } from './context/MenuContext';
import ForgotPassword from './Components/BeforeLogin/ForgotPassword';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; 
import UploadReport from './Components/IncidentManagement/UploadReport';
import DownloadReport from './Components/IncidentManagement/DownloadReport';
import DashboardManagement from './Components/IncidentManagement/DashboardManagement';
import ReleaseNote from './Components/BeforeLogin/ReleaseNote';
import Layout from './Components/Commons/Layout/Layout';
import AutoProcessReport from './Components/AutoProcessReport/Index';




const pathArr = [
  "/changepassword"
]


function App(props) {
  const accessToken = localStorage.getItem("accessToken");
  const tfaEnabled = localStorage.getItem("tfaEnabled");
  const otpVerified = localStorage.getItem("otpVerified");
  // const passwordUpdated = JSON.parse(localStorage.getItem("passwordUpdated"));
  // const locationPath = window.location.pathname;
  // // const idRedirect = !passwordUpdated && !pathArr.includes(locationPath);
  const menuArr = useMenu();
  // if (idRedirect){
  //   console.log("kop")
  //   window.location.href = "/changepassword"
  // }

  const menuArrNw = menuArr.menuArr;

  const resolveComponent = (id) => {
    const components = {
      "all-users": AllUser,
      "add-user": AddUser,
      "change-password": ChangePassword,
      "all-roles": AllRole,
      "add-role": AddRole,
      "all-permissions": AllPermission,
      "all-hotels": HotelListing,
      "add-hotel": AddHotel,
      "report-download": UsageReports,
      "edit-user": EditUser,
      "edit-hotel": EditHotel,
      "edit-role": EditRole,
      "report-verification": ReportVerification,
      "incident-report-dashboard": DashboardManagement,
      "incident-report-download": DownloadReport,
      "incident-report-upload": UploadReport,
      "max-hospital-report-download": BlkUsageReports,
      "auto-process-report": AutoProcessReport
    };
    return components[id];
  };
  // Find and resolve component for "Add/Edit Hotel"


  const protectedRoutes = [
    { path: "/dashboard", component: Dashboard, exact: true },
    // Add more as needed
  ];



  return (
    <Router>
      <ToastContainer autoClose={2000}/>
      <Switch>

        {/* If user is logged in, prevent access to login */}
        <Route exact path="/login" render={() => (
         accessToken ? <Redirect to={otpVerified || !tfaEnabled ? "/dashboard" : "/otp"} /> : <LoginFrom />
        )} />
        <Route
            exact
            path="/reset-password"
            render={() => (localStorage.getItem('accessToken') ? <Redirect to="/dashboard" /> : <ForgotPassword />)}
        />
         <Route
            exact
            path="/release-note"
            render={() => (localStorage.getItem('accessToken') ? <Redirect to="/dashboard" /> : <ReleaseNote />)}
        />
        {/* <Route exact path="/reset-password" component={ForgotPassword} /> */}
        {/* OTP Page should be accessible only if login was successful and 2FA is enabled */}
        <OtpRoute exact path="/otp" component={OtpFrom} />
        <ChangePasswordRoute exact path="/changepassword" component={ChangePasswordBeforeLogin}/>
        <Route exact path="/">
          <Redirect to="/dashboard" />
        </Route>
        <PrivateRoute path={["/dashboard"]}>
          <Layout routes={protectedRoutes} />
        </PrivateRoute>
        <PrivateRoute path="/">
          <Layout
            routes={menuArrNw.flatMap(menu => {
              console.log(menu,"menu")
              if (menu.type === "link") {
                return [{ path: `/${menu.id}`, component: resolveComponent(menu.id) }];
              }

              if (menu.subMenus && menu.subMenus.length > 0) {
                return menu.subMenus
                  .filter(sub => sub.type === "link")
                  .map(sub => ({
                    path: sub.url.includes(":id") ? `/${sub.id}/:id` : `/${sub.id}`,
                    component: resolveComponent(sub.id)
                  }));
              }

              return [];
            })}
          />
        </PrivateRoute>

        {/* {menuArrNw.map((menu) => {
          // Handle routes without subMenu
          if (menu.type === "link" ) {
            return <PrivateRoute key={menu.id} path={`/${menu.id}`} component={resolveComponent(menu.id)} />;
          }

          // Handle subMenu routes
          if (menu.subMenus && menu.subMenus.length > 0) {
            return menu.subMenus.map((subMenu) => {
              if (subMenu.type === "link" && subMenu.url) {
                // Check if URL has dynamic param (like :id)
                const dynamicPath = subMenu.url.includes(":id") ? `/${subMenu.id}/:id` : `/${subMenu.id}`;
        
                return (
                  <PrivateRoute key={subMenu.id} path={dynamicPath} component={resolveComponent(subMenu.id)} />
                );
              }
              return null;
            });
          }

          return null; // Skip if no valid route
        })} */}
        
        

        {/* <PrivateRoute path="/dashboard" component={Dashboard} /> */}
        {/* <Route path="/release-note" component={ReleaseNote} /> */}
       

        {/* <PrivateRoute path="/upload-report" component={UploadReport} />
        <PrivateRoute path="/download-report" component={DownloadReport} />
        <PrivateRoute path="/dashboard-management" component={DashboardManagement} /> */}

        {/* <PrivateRoute path="/usage-reports" component={UsageReports} />
        <PrivateRoute path="/add-user" component={AddUser} />
        <PrivateRoute path="/all-user" component={AllUser} />
        <PrivateRoute path="/edit-user/:id" component={EditUser} />
        <PrivateRoute path="/add-hotel" component={AddHotel} />
        <PrivateRoute path="/hotel-listing" component={HotelListing} />
        <PrivateRoute path="/edit-hotel/:id" component={EditHotel} />
        <PrivateRoute path="/add-role" component={AddRole} />
        <PrivateRoute path="/all-role" component={AllRole} />
        <PrivateRoute path="/edit-role/:id" component={EditRole} />
        <PrivateRoute path="/change-password" component={ChangePassword} />
        <PrivateRoute path="/usage-reports" component={UsageReports} /> */}
        {/* Default Redirect for unknown routes */}
        <Route path="*" render={() => <Redirect to="/login" />} />

        {/* <Route exact path="/logout" component={Logout} /> */}
      </Switch>
    </Router>
  );
}

export default App;
